/**
 * Static decoration marks for $ref{} syntax (L2 mode).
 * Status-aware marks with different colors for each resolution state.
 */

import { Decoration } from "@codemirror/view";
import type { RefStatus } from "../types";

export const refResolvedMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-resolved",
});
export const refUnresolvedMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-unresolved",
});
export const refPendingMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-pending",
});
export const refRunningMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-running",
});
export const refErrorMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-error",
});

export const refLoopVarMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-loop-var",
});

export const refScopeVarMark = Decoration.mark({
    class: "cm-magic-ref cm-magic-ref-scope-var",
});

export const refMarksByStatus: Record<RefStatus, Decoration> = {
    resolved: refResolvedMark,
    pending: refPendingMark,
    running: refRunningMark,
    error: refErrorMark,
    unresolved: refUnresolvedMark,
    "loop-var": refLoopVarMark,
    "scope-var": refScopeVarMark,
};
